import { useCallback, useEffect } from "react";
import { useLazyQuery } from "@grandvisionhq/graphql";
import { useDispatch } from "@grandvisionhq/state";
import "../../../../../../state/state/actions.js";
import "../../../../../../state/add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../state/bundles/state/bundles/selectors.js";
import "../../../../../../state/bundles/state/bundles/reducer.js";
import "../../../../../../state/configurator/state/configurator/selectors.js";
import "../../../../../../state/configurator/state/configurator/reducer.js";
import "../../../../../../state/products/state/products/selectors.js";
import "../../../../../../state/products/state/products/reducer.js";
import { GET_PRESCRIPTION_VALUES_FROM_DOCUMENT } from "../../../../operations/queries/steps/PrescriptionUploadStep/operations/queries/get-prescription-values-from-document.js";
import { mapPrescriptionRecognitionValuesToState } from "../../../../utils/steps/PrescriptionUploadStep/utils/map-prescription-recognition-values-to-state.js";
import { updatePrescriptionRecognitionValues } from "../../../../../../state/configurations/state/configurations/actions.js";
function useGetPrescriptionValues(frameSku) {
  const dispatch = useDispatch();
  const [execute, { data, loading }] = useLazyQuery(GET_PRESCRIPTION_VALUES_FROM_DOCUMENT);
  const fetchPrescriptionValues = useCallback(
    (storageId, storageToken) => {
      if (frameSku && storageId && storageToken) {
        execute({
          variables: { prescriptionDocument: { storageId, storageToken } },
          // Recognition needs more time to analyze the prescription
          context: { timeout: 2 * 6e4 }
        });
      }
    },
    [execute, frameSku]
  );
  useEffect(() => {
    if (frameSku && data) {
      const { prescriptionValues } = data.getPrescriptionValuesFromDocument;
      if (prescriptionValues) {
        dispatch(
          updatePrescriptionRecognitionValues({
            frameSku,
            left: mapPrescriptionRecognitionValuesToState(prescriptionValues.leftLens),
            right: mapPrescriptionRecognitionValuesToState(prescriptionValues.rightLens)
          })
        );
      }
    }
  }, [data, dispatch, frameSku]);
  return [fetchPrescriptionValues, loading];
}
export {
  useGetPrescriptionValues
};
//# sourceMappingURL=use-get-prescription-values.js.map
